import React from 'react'



function pypsyllabus() {
  return (
    <div>
<h1>Pyp Sylabus</h1>
    </div>
  )
}

export default pypsyllabus
